var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1456 8.1816C21.0064 8.2896 18.5488 9.6744 18.5488 12.7536C18.5488 16.3152 21.676 17.5752 21.7696 17.6064C21.7552 17.6832 21.2728 19.332 20.1208 21.012C19.0936 22.4904 18.0208 23.9664 16.3888 23.9664C14.7568 23.9664 14.3368 23.0184 12.4528 23.0184C10.6168 23.0184 9.964 23.9976 8.4712 23.9976C6.9784 23.9976 5.9368 22.6296 4.7392 20.9496C3.352 18.9768 2.2312 15.912 2.2312 13.0032C2.2312 8.3376 5.2648 5.8632 8.2504 5.8632C9.8368 5.8632 11.1592 6.9048 12.1552 6.9048C13.1032 6.9048 14.5816 5.8008 16.3864 5.8008C17.0704 5.8008 19.528 5.8632 21.1456 8.1816ZM15.5296 3.8256C16.276 2.94 16.804 1.7112 16.804 0.4824C16.804 0.312 16.7896 0.1392 16.7584 0C15.544 0.0456 14.0992 0.8088 13.228 1.8192C12.544 2.5968 11.9056 3.8256 11.9056 5.0712C11.9056 5.2584 11.9368 5.4456 11.9512 5.5056C12.028 5.52 12.1528 5.5368 12.2776 5.5368C13.3672 5.5368 14.7376 4.8072 15.5296 3.8256Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcloud);
export default __webpack_public_path__ + "static/media/icloud.366cbb214ec2cbb637a3e329544ef31a.svg";
export { ForwardRef as ReactComponent };